import { createRouter, useRouter } from "@tanstack/react-router";
import { AlertTriangle } from "lucide-react";
import { routeTree } from "./routeTree.gen";
import { Button } from "@/components/ui/button";
import { FullPageState } from "@/components/shared/FullPageState";

function DefaultErrorComponent({ error, reset }: { error: Error; reset: () => void }) {
  const router = useRouter();

  console.error("Router error:", error);

  return (
    <FullPageState
      icon={<AlertTriangle />}
      title="Something went wrong"
      description="An unexpected error occurred. Please try again."
      actions={
        <>
          <Button
            onClick={() => {
              router.invalidate();
              reset();
            }}
          >
            Try again
          </Button>
          <Button variant="outline" asChild>
            <a href="/">Go home</a>
          </Button>
        </>
      }
    >
      {import.meta.env.DEV && error.message && (
        <pre className="mt-6 max-h-40 overflow-auto rounded-md border border-border bg-card p-3 text-left font-mono text-code text-destructive">
          {error.message}
        </pre>
      )}
    </FullPageState>
  );
}

export const getRouter = () => {
  const router = createRouter({
    routeTree,
    context: {},
    scrollRestoration: true,
    defaultPreloadStaleTime: 0,
    defaultErrorComponent: DefaultErrorComponent,
  });

  return router;
};
